import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { Footer } from 'src/components/Quiz/Footer';
import { ScreenProps } from '@src/containers/QuizContainer/types';
import styles from './Welcome.module.scss';

export const Welcome: React.FC<ScreenProps> = props => {
	return (
		<div className={styles.container}>
			<Typography className={styles.typography} variant='h1'>
				We&apos;ve supported thousands of working adults in continuing their education.
			</Typography>
			<Typography className={styles.typography} variant='h1'>
				We&apos;re excited to have you on board.
			</Typography>
			<Footer onClickNext={props.nextScreen} />
		</div>
	);
};
